import Link from 'next/link'
import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding-bottom: 80px;
  padding-top: 40px;

  ${up('sm')} {
    padding-bottom: 120px;
    padding-top: 88px;
  }
`

const Title = styled.h5`
  margin-bottom: 40px;
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  text-align: center;

  ${up('sm')} {
    margin-bottom: 25px;
    padding-left: 15px;
    font-size: 20px;
    line-height: 24px;
    text-align: left;
  }
`

const Photo = styled.img`
  border-radius: 5px;

  ${up('sm')} {
    border-radius: 10px;
  }
`

const Text = styled.p`
  padding: 25px 16px 0 16px;
  color: #757d88;
  font-size: 15px;
  text-align: center;

  ${up('sm')} {
    font-size: 16px;
  }
`

const LineBreak = styled.br`
  ${up('sm')} {
    display: none;
  }
`

export const Team: ComponentType = () => (
  <Wrapper>
    <Container>
      <Row>
        <Col>
          <Title>Equipo Yucatán Premier</Title>
        </Col>
      </Row>
      <Row>
        <Col>
          <Text>
            Todos nuestros asesores y colaboradores persiguien un solo objetivo: ayudarte. <LineBreak />
            <Link href="/acerca/asesores">
              <a title="Conócelos aquí.">Conócelos aquí.</a>
            </Link>
          </Text>
        </Col>
      </Row>
    </Container>
  </Wrapper>
)
